import Service from "@/services/pagamentos.service"
import { Pagamento, PagePagamentoInput } from '@/models/pagamento'
import { router } from '@/router'


export const pagamento = {
  namespaced: true,
  state: {
    table: {
      header: [
        {
          text: "Pagamento ID",
          align: "start",
          sortable: false,
          value: "id"
        },
        {
          text: "Grupo",
          align: "start",
          sortable: false,
          value: "group"
        },
        {
          text: "Número Pedido",
          align: "start",
          sortable: false,
          value: "solicitation.raw"
        },
        {
          text: "Valor",
          align: "start",
          sortable: false,
          value: "value"
        },
        {
          text: "Empresa",
          align: "start",
          sortable: false,
          value: "company.name"
        },
        {
          text: "Data Pagamento",
          align: "start",
          sortable: false,
          value: "paid_at.formatted"
        },
        {
          text: "Status",
          align: "start",
          sortable: false,
          value: "status"
        },
        {
          text: "Criado em",
          align: "start",
          sortable: false,
          value: "created_at.formatted"
        },
        {
          text: "Ações",
          align: "center",
          sortable: false,
          value: "actions"
        }
      ],
      content: [] as Array<Pagamento>,
      paginate: {
        input: {
          solicitationId: null as number,
          companyId: null as number,
          status: null as string,
          value: null as string
        },
        inputPage: {
          page: 1,
          per_page: 10,
          sort: 'id:desc'
        },
      },
      isLoading: false,
      total: 0
    },
    detail: {
      data: {
        description: "",
      },
      isLoading: false
    }
  },
  mutations: {
    setTableIsLoading(state: any, value: boolean): void {
      state.table.isLoading = value
    },
    setTableContent(state: any, value: Pagamento[]): void {
      state.table.content = value
    },
    setTableTotal(state: any, value: number): void {
      state.table.total = value
    },
    setTablePaginate(state: any, value: PagePagamentoInput): void {
      state.table.paginate = value
    },
    setDetail(state: any, value: Pagamento): void {
      state.detail.data = value
    },
    setDetailIsLoading(state: any, value: boolean): void {
      state.detail.isLoading = value
    }

  },
  actions: {
    SEARCH({ commit, dispatch, state }: any): void {
      commit('setTableIsLoading', true)
      Service.list(state.table.paginate).subscribe(({ items, totalItems }) => {
        commit('setTableContent', items)
        commit('setTableTotal', totalItems)
        commit('setTableIsLoading', false)
      }, (error) => {
        commit('setTableIsLoading', false)
      })
    },
    CHANGE_PAGE({ commit, dispatch, state }: any, value: PagePagamentoInput): void {
      commit('setTablePaginate', value)
    },
    CLEAR({ commit }: any): void {
      commit('setTableContent', [])
      commit('setTableTotal', 0)
      commit('setTableIsLoading', false)
      commit('setTablePaginate', {
        input: {
          solicitationId: null as number,
          companyId: null as number,
          status: null as string,
          value: null as string
        },
        inputPage: {
          page: 1,
          per_page: 10,
          sort: 'id:desc'
        },
      })
    },
    async SHOW({ commit, dispatch, state }: any, value: number): Promise<any> {
      commit('setDetailIsLoading', true)
      try {
        const res = await Service.show(value).toPromise()
        commit('setDetail', res)
        commit('setDetailIsLoading', false)
      } catch (error) {
        commit('setDetailIsLoading', false)
      }
    },
    CLEAR_DETAIL({ commit, dispatch, state }: any): void {
      commit('setDetail', { description: "" })
      commit('setDetailIsLoading', false)
    },
    CREATE({ commit, dispatch, state }: any, value: Pagamento) {
      commit('setDetailIsLoading', true)
      Service.create(value).subscribe((res) => {
        commit('setDetail', res)
        commit('setDetailIsLoading', false)
        commit("global/setSnackBar", { show: true, message: "Pagamento Criado com sucesso", type: "success" }, { root: true });
        router.push({ name: 'dashboard-pagamentos-list' })
      }, (error) => {
        commit('setDetailIsLoading', false)
      })
    },
  },
}
